import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import PageMetaData from '@v4/utils/data/PageMetaData'
import { useVideo3 } from './Video3.hooks'
import VideoBlock from '../../components/VideoBlock'

const Video3 = props => {
	const [{ video }] = useVideo3(props)

	return (
		<Grid className="video3" container justify="center">
			<Grid className="video3-content" item xs={12} sm={10} md={8}>
				<VideoBlock className="video3-video-block" value={video} />
			</Grid>
		</Grid>
	)
}

Video3.propTypes = {
	metaData: PropTypes.shape({
		video: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Video3)
